import Insights from "./insights.js";

export default Insights;
